<template>
    <!-- 对账记录 -->
    <div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="submitForm">
                <el-form-item>
<!--                    <el-date-picker
                        v-model="submitForm.date"
                        value-format="yyyy-MM"
                        type="date"
                        placeholder="请选择对账日期"
                    ></el-date-picker> -->
					<el-date-picker v-model="submitForm.date" type="month" placeholder="请选择年月" format="yyyy 年 MM 月" value-format="yyyy-MM" :picker-options="pickerOptions">
					</el-date-picker>
                </el-form-item>
				<el-form-item>
				    <el-input clearable v-model="submitForm.phone" placeholder="请输入服务商账户"></el-input>
				</el-form-item>
				<el-form-item>
				    <el-input size clearable v-model="submitForm.agent_no" placeholder="请输入服务商编号"></el-input>
				</el-form-item>
				<el-form-item>
				    <el-select
				        size
				        v-model="submitForm.active_type"
				        clearable
				        placeholder="请选择账户类型"
				    >
				        <el-option label="对私" value="1"></el-option>
				        <el-option label="对公" value="2"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(submitForm)"
                    >查询</el-button>
                </el-form-item>
				<el-form-item>
				  <el-button
				      size="small"
				      type="primary"
				      icon="el-icon-download"
				      :loading="downLoading"
				      @click="handleDownLoad(submitForm)"
				  >导出数据</el-button>
				 <el-button size="medium" type="primary" icon="el-icon-plus" @click="frozenAddStock">批量修改开票状态</el-button>
				</el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="centerList" size="mini" border style="width: 100%" v-loading="loading">
                <!-- 序号 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    prop="id"
                    label="ID"
                    min-width="80"
                ></el-table-column> -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="year"
                    label="年份"
					width="80"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="month"
                    label="月份"
					width="80"
                ></el-table-column>
				<el-table-column
					header-align="center"
					align="center"
					prop="agent_no"
					label="服务商编号"
					width="150"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="user_no"
				    label="服务商账户"
				    width="150"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="user_name"
				    label="服务商名称"
				    width="200"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="user_type"
				    label="代理类型"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="user_account_type"
				    label="账户类型"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="transaction_money"
				    label="交易分润"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="active_money"
				    label="激活奖励"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="standard_money"
				    label="达标奖励"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="ladder_money"
				    label="阶梯奖励"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="flow_money"
				    label="流量卡奖励"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="person_money"
				    label="个人奖励"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="cash_money"
				    label="服务费返现"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="o_money"
				    label="服务费补垫轧差"
				    width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="p_money"
				    label="调账服务费轧差"
				    width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="q_money"
				    label="提现手续费收益"
				    width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="r_money"
				    label="调账金额轧差"
				    width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="s_money"
				    label="分期金额轧差"
				    width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="t_money"
				    label="补垫金额轧差"
				    width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="u_money"
				    label="调价奖励金额"
				    width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="total_money"
				    label="总额"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="need_invoice_money"
				    label="需开票金额"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="will_money"
				    label="待抵扣金额扎差"
				    width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="had_money"
				    label="实开票金额"
				    width="100"
				></el-table-column>
<!-- 				<el-table-column
				    header-align="center"
				    align="center"
				    prop="is_invoice"
				    label="开票状态"
				    width="100"
				></el-table-column> -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="user"
				    label="操作人"
				    width="100"
				></el-table-column>
				<!-- 操作 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    fixed="right"
				    label="操作"
				    width="200"
				>
					<template slot-scope="scope" >
                        <el-switch v-if="scope.row.user_account_type=='对公'"
                            v-model="scope.row.is_invoice"
                            active-text="已开票"
                            inactive-text="未开票"
                            :active-value="2"
                            :inactive-value="1"
                            @change="statusChange(scope.row)"
                        ></el-switch>
						<span v-if="scope.row.user_account_type=='对私'">-</span>
                    </template>
				</el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <!-- <record-info v-if="info.isShow" :info="info" @infoClose="handleCloseInfo"></record-info> -->
		
		<!--//批量修改开票状态-->
		<frozen-stock-tools
		  v-if="frozen"
		  :toolsIsShow="frozen"
		  @toolsClose="frozenToolsClose"
		></frozen-stock-tools>
    </div>
</template>

<script>
// import recordInfo from './components/contrastRecordDetail';
	import frozenStockTools from './frozen_stockTools';
export default {
    data() {
        return {
			rules: {
			    type: [{ required: true, message: '请选择对账类型', trigger: 'change' }],
			    date: [{ required: true, message: '选择对账日期', trigger: 'blur' }]
			},
			submitForm: {
				phone:"",
				active_type:"",
				agent_no:'',
			    date: '',
				page: 1,
				limit: 10
			},

            centerList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: false,
			downLoading: false, //导出loading
			pickerOptions: {
			        disabledDate(time) {
			          let year = new Date().getFullYear()
			          let month = new Date().getMonth()
			          let days = new Date(year, month, 0).getDate()
			          const timeDifference = days * 86400776 // 时间差
			          return time.getTime() > Date.now() - timeDifference;
			        }
			      },
				  frozen:false,

        }
    },
    components: {
frozenStockTools,
    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    methods: {
		//批量冻结
		frozenAddStock() {
		  this.frozen = true;
		},
		frozenToolsClose(ref) { //关闭导入
		  this.frozen = false;
		  if (ref) { //重载表格
		    this.getData({
		        page: 1,
		        limit: 10
		    })
		  }
		},
        handleSearch(searchFrom) { //搜索
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.submitForm.page = page;
            this.submitForm.limit = this.pageSize;
            this.getData(this.submitForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.submitForm.page = 1;
            this.submitForm.limit = limit;
            this.getData(this.submitForm);
        },
        getData(params) { //获取数据
            this.$api.post("export/file_list", params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.centerList = res.data.list;
                    // this.centerList = [];
                    //渲染结束后取消加载
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
		statusChange(row) { //改变状态
		    console.log(row)
		    this.$api.post('export/invoice_status', {
		        id: row.id,
		        is_invoice: row.is_invoice
		    }, res => {
		        if (res.code == 0) {
		            this.$message.success(res.msg);
		        } else {
		            this.$message.error(res.msg);
		            row.is_invoice = row.is_invoice == 1 ? 2 : 1;
		        }
		    })
		},
		handleDownLoad(params) { //导出
		  this.downLoading = true;
		  this.$api.post("export/file_list_download", params, res => {
		    if (res.code == 0) {
		      this.$message.success(res.msg);
		      var link=this.$file_url+res.data;
		      window.open(link)
		    } else {
		      this.$message.error(res.msg);
		    }
		    //渲染结束后取消加载
		    this.downLoading = false;
		  })
		},
    }
}
</script>

<style scoped lang="scss">
</style>